<template>
  <form class="form form-contact" @submit.prevent="postContact">
    <slide-x-left-transition :duration="400" :delay="200">
      <div class="form-group" v-show="show">
        <label>Twój e-mail</label>
        <div class="input-wrapper">
          <input v-model="form.email" type="email" placeholder="Podaj swój email"/>
        </div>
        <p class="error" v-if="errors.email">{{ errors.email[0] }}</p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="500" :delay="300">
      <div class="form-group" v-show="show">
        <label>Temat</label>
        <div class="select-wrapper">
          <span v-if="form.subject_id === null" class="select-placeholder">Wybierz temat</span>
          <select v-model="form.subject_id">
            <option v-for="item in subjects" :value="item.id">{{ item.subject }}</option>
          </select>
        </div>
        <p class="error" v-if="errors.subject_id">{{ errors.subject_id[0] }}</p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="600" :delay="400">
      <div class="form-group" v-show="show">
        <label>Treść wiadomości</label>
        <div class="input-wrapper">
          <textarea v-model="form.content" rows="5" placeholder="Wpisz treść wiadomości"/>
        </div>
        <p class="error" v-if="errors.content">{{ errors.content[0] }}</p>
      </div>
    </slide-x-left-transition>

    <ion-button mode="ios" expand="block" type="submit" :disabled="loading">
      <span v-if="loading"><span class="loader"></span></span>
      <span v-else>Wyślij</span>
    </ion-button>
  </form>
</template>

<script>
  import { mapState } from 'vuex';
  import goTo from '@/mixins/goto';

  function getDefaultFormData() {
    return {
      email: null,
      subject_id: null,
      content: null
    }
  }

  export default {
    name: 'FormContact',
    mixins: [goTo],
    data() {
      return {
        show: false,
        form: getDefaultFormData()
      }
    },
    computed: {
      ...mapState({
        errors: state => state.contact.errors,
        loading: state => state.contact.loading,
        subjects: state => state.contact.subjects
      })
    },
    mounted(){
      this.show = true;
    },
    methods: {
      postContact() {
        this.$store.dispatch('contact/CONTACT_FORM_REQUEST', this.form)
            .then(resp => {
              this.$store.dispatch('GLOBAL_TOAST',resp.data.message);
              this.form = getDefaultFormData();
              this.goBack();
            });
      }
    }
  }
</script>